import React from 'react';
import { Modal } from 'antd';
import Button from '../../common/Button/Button';

const MergeCartOnLoginModal = props => {
  const { visible, onCancel, onMergeCartAction, source } = props;
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      closable={false}
      footer={null}
      centered={true}
      title="Merge Cart?"
      wrapClassName="merge-cart-on-login-modal"
      getContainer={false}
    >
      <div className="merge-cart-on-login-modal--message">
        Some items already exist in your old cart.
        <br />
        Do you want to <span className="bold">MERGE</span> them with current
        cart?
        <br />
        OR
        <br />
        Do you want to <span className="bold">CONTINUE</span> with current cart?
      </div>
      <div className="merge-cart-on-login-modal--cta">
        <div className="justify-content--space-between">
          <Button
            className="button button-ghost full-width"
            onClick={() => onMergeCartAction({ mergeCart: true, source })}
          >
            Merge
          </Button>
          <div className="merge-cart-on-login-modal--empty-padding"></div>
          <Button
            className="button button-ghost full-width"
            onClick={() => onMergeCartAction({ mergeCart: false, source })}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MergeCartOnLoginModal;
